<template>
  <div class="page page--modal">
    <div class="flyout__modal-close" @click="cancel">
      <span class="flyout__modal-closex">X</span>
    </div>
    <div class="page__header">
      <div class="page__header-title">
        Add Admin
        <div class="page__header-subtitle">
          Add administrators for the tenant
        </div>
      </div>
    </div>
    <hr />
    <div class="page__body">
      <form ref="form" autocomplete="off" @submit.prevent="addUser()">
        <div class="form__content">
          <!-- <b-row class="form__row">
            <b-col>
              <b-form-group
                label="User Role"
                label-size="sm"
                label-class="form__label"
              >
                <span class="form__label-star">*</span>
                <b-form-select
                  v-model="userData.role"
                  :options="roleOptions"
                  required
                  size="sm"
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-row> -->
          <b-row class="form__row">
            <b-col>
              <b-form-group
                label="First Name"
                label-size="sm"
                label-class="form__label"
              >
                <span class="form__label-star">*</span>
                <b-form-input
                  v-model="userData.firstName"
                  placeholder="Enter First Name"
                  required
                  size="sm"
                  trim
                  maxlength="15"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label="Last Name"
                label-size="sm"
                label-class="form__label"
              >
                <span class="form__label-star">*</span>
                <b-form-input
                  v-model="userData.lastName"
                  placeholder="Enter Last Name"
                  required
                  size="sm"
                  trim
                  maxlength="15"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="form__row">
            <b-col>
              <b-form-group
                label="Password"
                label-size="sm"
                label-class="form__label"
              >
                <span class="form__label-star">*</span>
                <b-form-input
                  type="password"
                  v-model="userData.password"
                  placeholder="Enter Password"
                  required
                  size="sm"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label="Confirm Password"
                label-size="sm"
                label-class="form__label"
              >
                <span class="form__label-star">*</span>
                <b-form-input
                  type="password"
                  v-model="userData.confirmPwd"
                  placeholder="Confirm Password"
                  required
                  size="sm"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="mb-2 ml-1">
              <b-form-invalid-feedback :state="passwordMatch"
                >New password and confirm password does not
                match</b-form-invalid-feedback
              >
              <b-form-invalid-feedback :state="passwordCharacters"
                >Password should contain at least one uppercase, one special
                character and one numeric character, should be at least 8
                characters long, should not contain
                whitespaces.</b-form-invalid-feedback
              >
              <!-- <password-checker
                :password="userData.password"
                :confirmPassword="userData.confirmPwd"
                ref="passwordChecker"
              ></password-checker> -->
            </b-col>
          </b-row>
          <b-row class="form__row">
            <b-col>
              <b-form-group
                label="Email"
                label-size="sm"
                label-class="form__label"
              >
                <span class="form__label-star">*</span>
                <b-form-input
                  type="email"
                  v-model="userData.email"
                  placeholder="Enter Email"
                  required
                  size="sm"
                  :formatter="formatter"
                  trim
                  pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                  maxlength="45"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <hr />
        <div class="form__buttons">
          <b-button
            class="form__button"
            size="sm"
            variant="light"
            @click="cancel()"
            >Cancel</b-button
          >
          <b-button
            class="form__button"
            size="sm"
            variant="success"
            type="submit"
            >Add</b-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
export default {
  data: function () {
    return {
      userData: {},
    };
  },

  props: [],

  computed: {
    passwordMatch() {
      if (this.userData.password && this.userData.confirmPwd)
        return this.userData.password === this.userData.confirmPwd;
      return true;
    },

    passwordCharacters() {
      let string = this.userData.password;
      if (
        string == undefined ||
        (/\d/.test(string) &&
          /[a-z]/.test(string) &&
          /[A-Z]/.test(string) &&
          /[*.!@#$%^&(){}:";'<>,.?/`_+-=|\\]/.test(string) &&
          !/\s/g.test(string) &&
          string.length > 7)
      ) {
        return true;
      }
      return false;
    },
  },

  mounted() {},

  methods: {
    cancel(e) {
      this.$emit("cancel");
    },

    formatter(value) {
      return value.toLowerCase();
    },

    addUser() {
      if (this.passwordMatch && this.passwordCharacters) {
        this.$emit("addUser", { user: this.userData });
      }
    },
  },
};
</script>

<style>
.form__label {
  float: left;
  width: auto;
  color: black;
  font-weight: 500;
}

.form__label-star {
  color: #8B0000;
}

.form__buttons {
  float: right;
  width: 40%;
}

.form__button {
  width: 50%;
}
</style>
